import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { camelCase } from 'lodash';

import { AB_API_DOMAIN, AB_API_BASE } from './../constants';

interface ApiResponse {
  callIsSuccess?: boolean;
  errorCode?: any;
  errorSubCode?: any;
  errorMessage?: string;
  errorDescription?: string;
  data?: any;
}

export class ApiClientService {
  public url: string;

  constructor(private http: HttpClient, private resource: string) {
    this.url = AB_API_DOMAIN + AB_API_BASE + this.resource;
  }
  public get(item?: { [param: string]: any }): Observable<any> {
    return this.http
      .get(this.url, {
        withCredentials: true,
        params: item
      })
      .pipe(
        map(response => ApiClientService.camelCaseResponse(response)),
        catchError(err => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  public getWithoutLoader(item?: { [param: string]: any }): Observable<any> {
    return this.http
      .get(this.url, {
        withCredentials: true,
        params: item,
        headers: {
          withoutLoader: 'without'
        }
      })
      .pipe(
        map(response => ApiClientService.camelCaseResponse(response)),
        catchError(err => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  public post(item?: Object): Observable<any> {
    return this.http
      .post(this.url, item, {
        withCredentials: true
      })
      .pipe(
        map(response => ApiClientService.camelCaseResponse(response)),
        catchError(err => {
          console.error(err);
          return throwError(err);
        })
      );
  }

  public postWithButtonLoader(item?: Object): Observable<any> {
    return this.http
      .post(this.url, item, {
        withCredentials: true,
        headers: {
          withButtonLoader: 'with'
        }
      })
      .pipe(
        map(response => ApiClientService.camelCaseResponse(response)),
        catchError(err => {
          console.error(err);
          return throwError(err);
        })
      );
  }

  public putWithButtonLoader(item?: Object): Observable<any> {
    return this.http
      .put(this.url, item, {
        withCredentials: true,
        headers: {
          withButtonLoader: 'with'
        }
      })
      .pipe(
        map(response => ApiClientService.camelCaseResponse(response)),
        catchError(err => {
          console.error(err);
          return throwError(err);
        })
      );
  }

  public put(item?: Object): Observable<any> {
    return this.http
      .put(this.url, item, {
        withCredentials: true
      })
      .pipe(
        map(response => ApiClientService.camelCaseResponse(response)),
        catchError(err => {
          console.error(err);
          return throwError(err);
        })
      );
  }

  public delete(item?: { [param: string]: any }): Observable<any> {
    return this.http
      .delete(this.url, {
        withCredentials: true,
        params: item
      })
      .pipe(
        map(response => ApiClientService.camelCaseResponse(response)),
        catchError(err => {
          console.error(err);
          return throwError(err);
        })
      );
  }

  protected static camelCaseResponse(response: any) {
    if (Array.isArray(response)) {
      return response.map(v => ApiClientService.camelCaseResponse(v));
    } else if (response !== null && response.constructor === Object) {
      return Object.keys(response).reduce(
        (result, key) => ({
          ...result,
          [camelCase(key)]: ApiClientService.camelCaseResponse(response[key])
        }),
        {}
      );
    }
    return response;
  }
}

export { ApiResponse };
